import moment from 'moment/moment'

import { Field } from '../../models/Field'
import { currencyFormat } from '../../utils/numbers'
import { e164ToPhone } from '../../utils/phone'
import { Icon } from '../Icon'
import Label from '../app/design/Label'
import Paragraph from '../app/design/Paragraph'

type Props = {
    field: Field
    value: any
}

export const CustomFieldView = ({ field, value }: Props) => {
    switch (field.type) {
        case 'currency': {
            return currencyFormat(value ?? 0)
        }
        case 'checkbox': {
            return Boolean(value) ? 'Yes' : 'No'
        }
        case 'email': {
            return value ?? ''
        }
        case 'float': {
            return value ?? 0
        }
        case 'integer': {
            return value ?? 0
        }
        case 'longtext': {
            return value ?? ''
        }
        case 'phone': {
            return e164ToPhone(value ?? '')
        }
        case 'date': {
            return moment(value).format('MM/DD/YYYY')
        }
        case 'multiselect': {
            const selectedIDs = value ?? []
            return field.options
                .filter((option) => selectedIDs.includes(option.id ?? ''))
                .map((option) => option.label ?? '')
                .join(', ')
        }
        case 'select': {
            return field.options.find((option) => option.id === value)?.label ?? ''
        }
        case 'image': {
            if (!value.url) {
                return null
            }
            return <img src={value.url} alt={field.label} />
        }
        case 'document': {
            return (
                <a
                    href={value.uri}
                    target="_blank"
                    rel="noreferrer"
                    className="flex w-full items-center justify-center gap-x-4 rounded-lg border border-gray-300 bg-gray-100 px-4 py-3 text-left hover:bg-gray-300"
                >
                    <Icon
                        icon="file.medium"
                        background="round"
                        backgroundColorClassName="bg-gray-600"
                        className="text-white"
                        shouldInheritColor
                    />
                    <div className="shrink grow">
                        <Label size="sm" className="mb-1 text-gray-700">
                            {value.name ?? 'Document'}
                        </Label>
                        <Paragraph size="sm" className="text-gray-600">
                            PDF
                        </Paragraph>
                    </div>
                    <Icon icon="chevronRight.medium" className="text-gray-600" />
                </a>
            )
        }
        case 'text':
        case '':
        default:
            if (typeof value === 'object') {
                return ''
            }
            return value ?? ''
    }
}
